<template>
    <div id="sms-admin-messages" class="container-fluid main-content page-content">
        <div class="page-header">
            <div>
                <h3 class="page-title">{{ $t('all-sms-conversations') }}</h3>
                <p class="page-subtitle">{{ smsNumber }}</p>
            </div>
        </div>
        <div class="sms-admin-menu">
            <ul class="page-tabs">
                <li class="page-tab" :class="{'active':currentSection === OTHER_USERS_CONVERSATIONS_SECTION}">
                    <router-link :to="{ name: '' }"
                        @click.native="switchSection(OTHER_USERS_CONVERSATIONS_SECTION)">
                        {{ $t('active-conversation')}} ({{ otherUsersConversations && otherUsersConversations.meta.page ? otherUsersConversations.meta.page.total : 0 }})
                    </router-link>
                </li>
                <li class="page-tab" :class="{'active':currentSection === WITHOUT_USERS_CONVERSATIONS_SECTION}">
                    <router-link :to="{ name: ''}"
                        @click.native="switchSection(WITHOUT_USERS_CONVERSATIONS_SECTION)">
                        {{ $t('sms-in-waiting') }} ({{ noUsersConversations && noUsersConversations.meta.page ? noUsersConversations.meta.page.total : 0 }})
                    </router-link>
                </li>
                <li class="page-tab" :class="{'active':currentSection === CURRENT_USER_CONVERSATIONS_SECTION}">
                    <router-link :to="{ name: ''}"
                        @click.native="switchSection(CURRENT_USER_CONVERSATIONS_SECTION)">
                        {{ $t('sms-my-conversations') }} ({{ currentUserConversations && currentUserConversations.meta.page ? currentUserConversations.meta.page.total : 0 }})

                        <!-- Notification bulle of new messages (hidden for now) -->
                        <BulleNbrNewMessages v-if="false"></BulleNbrNewMessages>
                    </router-link>
                </li>
            </ul>
        </div>
        <!-- All conversations section -->
        <conversations-box @switchSection="switchSection($event.to)" :currentSection="currentSection" :loadingNumber="loadingNumber"></conversations-box>
    </div>
</template>

<script>

// Components
import ConversationsBox    from './ConversationsBox.vue';
import BulleNbrNewMessages from '../BulleNbrNewMessages.vue';

// Import external libraries
import {
    mapState, mapActions
} from 'vuex';
import Format from '@/helpers/Format.js';

export default {
    data () {
        // Available admin sections
        const OTHER_USERS_CONVERSATIONS_SECTION   = 'other-users-conversartions';
        const WITHOUT_USERS_CONVERSATIONS_SECTION = 'without-users-conversartions';
        const CURRENT_USER_CONVERSATIONS_SECTION  = 'current-user-conversartions';

        return {
            OTHER_USERS_CONVERSATIONS_SECTION,
            WITHOUT_USERS_CONVERSATIONS_SECTION,
            CURRENT_USER_CONVERSATIONS_SECTION,

            smsNumber:      '',
            currentSection: OTHER_USERS_CONVERSATIONS_SECTION,

            // Loadings
            loadingNumber: false
        };
    },

    components: {
        ConversationsBox,
        BulleNbrNewMessages
    },

    computed: {
        ...mapState('core/conversations', [
            'currentUserConversations',
            'noUsersConversations',
            'otherUsersConversations'
        ]),

        ...mapState('core/number', [
            'phoneNumber'
        ]),
    },

    mounted () {
        // Get the SMS numbers linked to the tenant
        this.getActivePhoneNumber();
    },

    methods: {
        formatPhoneNumber: Format.formatPhoneNumber,

        /**
         * Methods to get SMS active Number API request
         *
         * getPhoneNumber     API list sms numbers
         */
        ...mapActions('core/number', { getPhoneNumber: 'index' }),

        /**
         * Get the active phone number
         */
        getActivePhoneNumber () {
            this.loadingNumber = true;

            this.getPhoneNumber({})
                .then(() => {
                    for (const numberId in this.phoneNumber) {
                        this.smsNumber = Format.formatPhoneNumber(this.phoneNumber[numberId].attributes['phone-number']);
                    }
                })
                .finally(() => {
                    this.loadingNumber = false;
                });
        },

        /**
         * Switch between sections
         *
         * @param {string}  to  the section to switch to
         * @return void
         */
        switchSection (to) {
            this.currentSection = to;
        }
    }
};
</script>
